// eslint-disable-next-line import/no-unresolved
import { css, keyframes } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import {
  PURPLE,
  WHITE,
  PURPLE_LIGHT,
  PURPLE_DARK_HEADER,
  PINK,
  GRAY,
  GRAY_TEXT
} from '../../../constants/colors';
import { BUYING } from '../../../constants/zIndex';

const blink = keyframes`
  0% {
      height: 12px;
      background-color: ${PURPLE_LIGHT};
    }
    35% {
      height: 20px;
      background-color: ${PINK};
    }
    70%, 100% {
      height: 12px;
      background-color: ${PURPLE_LIGHT};
    }
`;

export default {
  wrapper: css`
    background-color: #ffffff;
    padding: 3%;
    ${media.sm`
      position: sticky;
      padding: 16px 6% 16px;
    `};
  `,
  contentWrapper: ({ translate }) => css`
    flex: 1;
    padding: 16px 16px 16px;
    ${translate && 'transform: translateY(-30%);'}
    ${media.md`
      padding: 0;
      ${translate && 'transform: translateY(-50%);'}
    `};
  `,

  contentWrapperInputs: css`
    flex: 1;
    padding: 16px 0px 2px 0px;

    ${media.sm`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    `};
  `,
  labelTop: css`
    font: 16px Arial, sans-serif;
    line-height: 1.5;
    color: #000000;
    margin-bottom: 0.5rem;
    margin-left: 7px;
  `,

  contentWrapperInputsSmall: css`
    padding: padding: 0px 0px 13px 0px;

    ${media.mn`
    display: flex;
      flex: wrap;
    `};

    ${media.mn1`
    display: flex;
      flex: wrap;
    `};

    ${media.sm`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    `};
  `,
  grayContainer: css`
    background-color: #d8d8d8;
    // width: 100%;
    padding: 1% 5%;
    border-radius: 15px;
    font-size:15px;
    ${media.sm`
      // display: grid;
      // padding: 2% 5%;
      // grid-template-columns: repeat(2, 1fr);
      // width: 50%;
    `};
  `,
  cartSection: () => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
    ${media.sm`
      // width: 90%;
    `}
  `,
  labelInput: ({ color, size, weight }) => css`
  color: ${color || GRAY_TEXT};
  font-size: 14px
  margin-top: 10px;
  margin-botom:30px;
  // padding-left: 30px;
  font-weight: ${weight || 700} ;
  font-size: ${size || '12px'};
`,

  labelight: ({ color, size }) => css`
    color: ${color || GRAY_TEXT};
    font-family: 'Open Sans', sans-serif;
    font-size: ${size || '12px'};
    // margin-top: 10px;
    padding-left: 30px;
    font-weight: 100;
  `,

  destinationWrapper: css`
    display: grid;
    cursor: pointer;
    background-color: white;
    justify-content: center;
    width: 85%;
    height: auto;
    border-radius: 15px;
    margin: auto;
    padding-inline: 4%;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 10px !important;
    margin-bottom:16px;
    box-shadow: 0px 0px 3px 3px rgba(125, 125, 125, .6);
    ${media.md`
      padding-top: 4px;
      height: auto;
      margin-bottom:16px;
      // margin-bottom:100px;
      display:flex;
    `};
  `,

  wrapperTicketInfo:css`
    display: grid;
    cursor: pointer;
    background-color: white;
    justify-content: center;
    width: 100%;
    height: auto;
    border-radius: 15px;
    margin: auto;
    padding-inline: 4%;

  ${media.md`
    padding-top: 4px;
    height: auto;
    margin-bottom: 16px;
    display:flex;
  `};
`,

  destinationToggle: ({ grow }) => css`
    ${!grow
      && css`
        width: 42px;
        height: 42px;
        margin: 0 42px;
      `} ${grow
      && css`
        width: 42px;
        height: 42px;
        margin: 0 42px;
      `}
    align-self: center;

    ${media.sm`
      ${!grow
        && css`
          width: 36px;
          height: 36px;
          margin: 0 8px;
        `}
      ${grow
        && css`
          width: 36px;
          height: 36px;
          margin: 0 8px;
        `}
    `};
  `,

  buyingWrapperMobile: ({ isBuyingActive }) => css`
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: white;
    height: 64px;
    bottom: -68px;
    left: 0;
    background-color: ${PURPLE};
    z-index: ${BUYING};
    transition: all 0.2s ease-in-out;

    @media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
      padding-top: 28px;
      padding-bottom: 40px;
    }

    ${isBuyingActive
      && css`
        bottom: 0;
        transition: all 0.2s ease-out;
      `} ${media.sm`
      display: none;
    `};
  `,
  price: ({ isSavingMoney }) => css`
    display: flex;
    justify-content: center;
    font-size: ${rem(isSavingMoney ? '16px' : '32px')};
    flex: 1;
    color: ${WHITE};
    padding-left: 26px;

    ${media.sm`
      font-size: ${rem('20px')};
    `} span {
      text-decoration: line-through;
      color: ${GRAY};
      opacity: 0.7;
    }
  `,

  infoWrapper: ({ color }) => css`
    background-color: ${color || WHITE};
  `,

  info: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: ${rem(isTotal ? '24px' : '16px')};
    color: ${PURPLE_LIGHT};
    margin-bottom: 16px;
    text-align: ${textAlign || 'left'};

    ${isTotal
      && css`
        flex: 1;
        margin-left: 8px;
        justify-self: flex-start;
        margin-bottom: 0;
        line-height: ${rem('32px')};
        margin-right: 24px;

        ${media.sm`
        font-size: ${rem(isSavingMoney ? '13px' : '20px')};
      `} ${media.md`
        font-size: ${rem(isSavingMoney ? '20px' : '24px')};
      `};
      `} ${maxWidth
      && css`
        max-width: 85%;
        margin-top: 8px;

        ${media.sm`
        max-width: ${maxWidth};
      `};
      `}

    span {
      text-decoration: line-through;
      color: ${GRAY};
    }
  `,

  checkBoxesWrapper: css`
    margin-top: 16px;
  `,

  buyingWrapperDesktop: css`
    position: relative;
    display: none;

    ${media.sm`
      display: block;
    `};
  `,

  buyingWrapperDesktopContent: css`
    display: flex;
    position: relative;
    height: 100%;
    align-items: center;
    justify-content: flex-end;
    z-index: 1;
  `,

  buyingWrapperDesktopBackground: css`
    position: absolute;
    width: 100vw;
    height: 100%;
    top: 0;
    left: 17px;
    background-color: ${PURPLE_DARK_HEADER};
  `,

  buyingWrapperDesktopArrow: css`
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 100px solid ${PURPLE_DARK_HEADER};
    border-left: 17px solid transparent;
    top: 0;
    left: -17px;
  `,

  mobile: css`
    display: block;

    ${media.sm`
      display: none;
    `};
  `,

  desktop: ({
    isBuying, isProcessing, isSucess, hasError, promoOffset
  }) => css`
    display: none;

    ${media.sm`
      position: absolute;
      overflow: hidden;
      height: 0;
      display: block;
      transition: height 0.3s ease-in-out;
      will-change: height;
      left: 0;
      z-index: 1999;
      background-color: ${WHITE};
      width: 100%;

      ${isBuying
        && css`
          height: ${540 + promoOffset}px;
        `}

      ${hasError
        && css`
          top: 236px;
          transition: top 0.3s ease-in-out;
        `}

      ${isProcessing
        && css`
          height: 50px;
        `}

      ${isSucess
        && css`
          height: 360px;
        `}
    `};
  `,

  desktopForm: ({ isProcessing, isSucess }) => css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    will-change: top;
    transition: top 0.3s ease-in-out;

    ${isProcessing
      && css`
        top: 50px;
      `} ${isSucess
      && css`
        top: 338px;
      `};
  `,

  paymentProcessingDesktop: ({
    isVisible, origin, goTo, backgroundColor
  }) => css`
    position: absolute;
    top: ${origin}px;
    left: 0;
    right: 0;
    will-change: top;
    transition: top 0.3s ease-in-out;
    background-color: ${backgroundColor || WHITE};
    display: ${isVisible ? 'block' : 'none'};

    ${isVisible
      && css`
        top: 0px;
      `} ${goTo
      && css`
        top: ${goTo}px;
      `};
  `,

  contactInformationWrapper: css`
    margin-top: 32px;
    padding-right: 16px;
  `,

  paymentInformationWrapper: css`
    margin-top: 16px;
    padding: 10px 10px 0px 10px;
  `,

  cartTicketsListWrapper: css`
    margin-top: 16px;
    margin-bottom: 16px;
    width: 100%;
  `,

  cartTotalWrapper: css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1em;
  `,
  cartTotal: css`
    color: ${PINK};
  `,

  totalWrapperDesktop: css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 48px;
  `,

  circleBlink: ({ delay }) => css`
    margin: 0 4px;
    width: 12px;
    height: 20px;
    border-radius: 12px;
    background-color: red;
    animation: ${blink} 1s ease-in-out infinite;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-delay: ${delay * 0.13}s;
  `,

  circleBlinkWrapper: ({ isProcessing }) => css`
    display: ${isProcessing ? 'flex' : 'none'};
    flex: 0 0 100%;
    height: 50px;
    align-items: center;
    justify-content: center;
  `,

  ticketImage: css`
    width: 100%;
    margin-bottom: 8px;

    ${media.sm`
      margin-top: 8px;
      margin-bottom: 8px;
    `};
  `,

  showTicketWrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 16px 32px 16px;

    ${media.sm`
      padding: 0 20px 0 0;
    `};
  `,

  downloadTicket: css`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${media.sm`
      width: 50%;
    `};
  `,

  closeIconWrapper: css`
    cursor: pointer;
    margin-top: 8px;
    align-self: flex-end;
  `,

  errorWrapper: ({ hasError, isBuying }) => css`
    display: flex;
    justify-content: center;
    overflow: hidden;
    color: black;
    background-color: #e8e68d;
    max-height: 0;
    height: auto;

    will-change: max-height;
    transition: max-height 0.3s ease-in-out, height 0.3s ease-in-out;

    ${media.sm`
      ${isBuying
        && css`
          position: fixed;
          left: 0;
          top: 196px;
          z-index: 666667;
          width: 100%;
        `}
    `} p {
      margin: 0;
      padding: 8px 32px;

      ${media.sm`
        padding: 8px;
      `};
    }

    ${hasError
      && css`
        height: auto;
        max-height: 200px;
      `};
  `,

  containerPurpleButton: ({ backgroundColor }) => css`
  ${media.sm`
  flex-direction: column;
  text-align: center;
  font-size: 25px;
  width: 250px;
  height: 250px;
  margin: 0 50px 30px;
`};
    display: flex;
    width: 90%;
    padding: 3%;
    color: white;
    font-size: 20px;
    font-weight: bold;
    justify-content: space-around;
    margin: auto;
    margin-bottom: 20px;
    cursor: pointer;
    background-color: ${backgroundColor || '#3f2a55'};
    border-radius: 15px;
    &:hover {
      background-color: #E05C96;
    };
  `,

  buttonWrapper: ({ status, width, height, disabled }) => css`
  display: flex;
  ${!(status === 'disabled' || status === 'valid')
    && css`
      cursor: pointer;
    `}
  justify-content: center;
  align-items: center;
  // border: 1px solid ;
  height: ${height || '32px'};
  width: ${width || 'auto'};
  border-radius: 11px;
  color:${WHITE};
  background-color: #ff3094;
  font-weight: 800;
  padding-inline: 40px;
  margin-left:10px;
  margin-bottom:10px
`,
  buttonsContainer: () => css`
    flex-direction: row;
    display: inline-flex;
    flex-wrap: wrap;
    // margin-top: 20px;
    justify-content: space-around;
    ${media.mn1`
      display: contents;
      justify-content: space-around;
      flex-direction: column;
    `};
    ${media.sm`
      flex-direction: row;
      display: inline-flex;
      flex-wrap: wrap;
      width: 100%;
  `};
  `,
  pinkLabel: () => css`
    font-size: 18px;
    color: #EF60A3;;
    text-align: center;
  `,
  purpleLabel: () => css`
    font-size: 16px;
    color: #3F2A55;
    text-align: center;
    padding: 0px 0px 20px;
  `,
  inputRounderSelect: ({
    type, width, padding, hasBlackTheme, value, isSorting, textColor
  }) => css`
  border-radius: 10px;
  border-bottom: 1px solid ${GRAY_TEXT};
  font-weight: bolder;
  color: #726C79;
  font-size: 1rem;
  padding-inline: 5px 0;
  width: ${width || '100%'};
  height: 34px;
  margin-left ${padding || 0};
  border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};
  background-color: white;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  overflow: hidden;
  background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 95% 50%;

  ${value === '' && hasBlackTheme && css`
    color: #757575;
  `}

  ${isSorting && css`
    border: none;
  `}

  ${type === 'date' && !textColor && css`
    &::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  `}
  option {
    color: black;
    font-size: ${rem('16px')};
  }
`,


  warnLabel: () => css`
    font-size: 12px;
    margin-top: 10;
    margin-top: -1rem;
    margin-left: 7px;
    color: red;
    margin-bottom: 1rem;
  `,
};
